<template>
  <div class="media-modal__overlay">
    <div
      class="media-modal"
      :class="{
        'media-modal--mobile':
          this.$store.state.layout.isMobile ||
          this.$route.name == 'MeetingRoom' ||
          this.$route.name == 'AnytimeMeetingRoom',
      }"
      :style="{
        'max-height': innerHeight + 'px',
      }"
    >
      <div class="media-modal__head">
        <div
          class="media-modal__head-group"
          v-if="this.$route.name == 'Specialist'"
        >
          <div class="media-modal__title">Videoclip de prezentare</div>
          <div class="media-modal__close" @click="$emit('toggleMediaModal')">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div
          class="media-modal__close"
          @click="$emit('toggleMediaModal')"
          v-else
        >
          <i class="fa fa-times"></i>
        </div>
        <div
          class="media-modal__subtitle"
          v-if="this.$route.name == 'Specialist'"
        >
          {{ specialist.full_name }}
        </div>
      </div>
      <div class="media-modal__body">
        <img
          :src="imageUrl"
          alt="Specialist Video"
          v-if="mediaType == 'image'"
        />
        <video ref="modalVideo" controls v-if="mediaType == 'video'" class="media-modal__video">
          <source :src="videoUrl + '#t=0.5'" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <iframe v-if="mediaType == 'embed'" :src="videoUrl + (this.autoplay ? '#autoplay' : '')" width="100%" height="100%" frameborder="0" scrolling="no" allowfullscreen="true"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    mediaType: {
      type: String,
      default: "",
    },
    videoUrl: {
      type: String,
      default: "",
    },
    imageUrl: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters({
      specialist: "specialist/specialist",
    }),
  },
  data() {
    return {
      innerHeight: 0,
    };
  },
  mounted() {
    document.body.style.overflow = "hidden";
    this.innerHeight = window.innerHeight;

    let VueThis = this;
    function resetModalHeight() {
      if (window.innerWidth <= 576)
        //SM
        VueThis.innerHeight = window.innerHeight;
    }

    if(this.autoplay){ //autoplay after one second
        this.$refs.modalVideo.play();
    }


    resetModalHeight();
    window.onscroll = function () {
      resetModalHeight();
    };
    window.onresize = function () {
      resetModalHeight();
    };
    window.onorientationchange = function () {
      resetModalHeight();
    };
  },
  destroyed() {
    document.body.style.overflow = null;
  },
};
</script>

<style lang="scss" scoped>
.media-modal {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: calc(50% + 140px);
  transform: translate(-50%, -50%);
  padding: 20px;
  width: 100%;
  height: 100%;
  z-index: 21;
  background-color: white;

  @include media-breakpoint-up(sm) {
    max-width: 960px;
    height: initial;
  }
  @include media-breakpoint-down(sm) {
    position: fixed;
  }

  &--mobile {
    left: 50%;
  }

  &__head-group {
    display: flex;
    justify-content: space-between;
  }

  &__overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    z-index: 21;
  }

  &__head {
    display: flex;
    flex-direction: column;
    // align-items: center;
    // justify-content: flex-end;
    // height: 25px;
    // position: absolute;
    // right: 20px;
    // top: 20px;
  }

  &__title {
    color: $color-main-text;
    font-family: "DIN Pro", sans-serif;
    font-weight: 700;
    font-size: 24px;
  }

  &__subtitle {
    font-family: "Roboto", sans-serif;
    margin-top: 12px;
    margin-bottom: 12px;
    font-size: 14px;
    color: #373435;
    opacity: 0.7;
  }

  &__close {
    font-size: 25px;
    cursor: pointer;
    margin-left: auto;
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    @include media-breakpoint-up(sm) {
      max-height: calc(100% - 35px);
    }

    img {
      display: block;
      margin: auto;
      min-height: 80vh;
      max-height: 80vh;
      max-width: 100%;
      object-fit: contain;

      &,
      &:focus {
        outline: none;
      }
    }

    video {
      display: block;
      margin: auto;
      width: auto;
      width: 100%;
      max-width: 100%;
      object-fit: cover;
      &,
      &:focus {
        outline: none;
      }
    }

    iframe{
      display: block;
      margin: auto;
      width: auto;
      width: 100%;
      max-width: 100%;
      min-height: 515px;
      max-width: 100%;

      &,
      &:focus {
        outline: none;
      }
    }
  }
}
</style>